import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/ESPAirQualityIndustrialHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-30.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .eai { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO (no border-top) ══ */
  .eai-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .eai-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .eai-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .eai-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .eai-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .eai-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .eai-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .eai-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .eai-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .eai-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .eai-bc-item:hover { color: #EB2019; }
  .eai-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .eai-bc-sep img { width: 24px; height: 24px; display: block; }
  .eai-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .eai-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .eai-main-section { padding: 80px 0 120px 0; }
  .eai-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .eai-article { flex: 1; min-width: 0; }

  .eai-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .eai-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .eai-meta-item:last-child { border-right: none; padding-right: 0; }
  .eai-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .eai-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .eai-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .eai-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .eai-article-body p { margin-bottom: 20px; }
  .eai-article-body p:last-child { margin-bottom: 0; }

  .eai-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  .eai-h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 20px 0 0px 0; line-height: 160%; display: block;
  }

  /* Numbered ol list */
  .eai-article-body ol {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
    counter-reset: eai-counter;
  }
  .eai-article-body ol li {
    display: flex; align-items: flex-start; gap: 8px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; counter-increment: eai-counter;
  }
  .eai-article-body ol li::before {
    content: counter(eai-counter) '.';
    font-weight: 600; color: #202020;
    flex-shrink: 0; min-width: 20px;
  }
  .eai-article-body ol li > span { flex: 1; }

  .eai-article-body strong { font-weight: 600; color: #202020; }

  .eai-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .eai-red-link:hover { opacity: 0.8; }
  .eai-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 400; }
  .eai-red-link-plain:hover { opacity: 0.8; }

  /* Hashtags */
  .eai-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .eai-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .eai-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .eai-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .eai-nav-btn:hover { color: #EB2019; }
  .eai-nav-btn img { width: 40px; height: 40px; display: block; }

  .eai-share-icons { display: flex; align-items: center; gap: 20px; }
  .eai-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .eai-share-icon:hover { opacity: 0.85; }
  .eai-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .eai-sidebar { flex: 0 0 475px; }
  .eai-sidebar-block { margin-bottom: 60px; }
  .eai-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .eai-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .eai-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .eai-recent-item:hover .eai-recent-title { color: #EB2019; }
  .eai-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .eai-recent-body { flex: 1; min-width: 0; }
  .eai-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .eai-social-icons { display: flex; align-items: center; gap: 30px; }
  .eai-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .eai-social-icon:hover { opacity: 0.8; }
  .eai-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .eai-hero             { height: 350px; }
    .eai-hero-content     { padding: 0 32px; }
    .eai-hero-title       { font-size: 30px; }
    .eai-hero-divider     { width: 100%; max-width: 479px; }
    .eai-breadcrumb       { padding: 24px 0 0 0; }
    .eai-breadcrumb-inner { padding: 0 32px; }
    .eai-inner            { padding: 0 32px; }
    .eai-main-section     { padding: 48px 0 60px 0; }
    .eai-main-row         { flex-direction: column; gap: 48px; }
    .eai-sidebar          { flex: none; width: 100%; }
    .eai-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .eai-hero             { height: 360px; }
    .eai-hero-content     { padding: 0 16px; }
    .eai-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .eai-hero-divider     { width: 100%; }
    .eai-hero-subtitle    { font-size: 14px; }
    .eai-breadcrumb       { padding: 30px 0 0 0; }
    .eai-breadcrumb-inner { padding: 0 16px; }
    .eai-bc-item          { font-size: 14px; gap: 14px; }
    .eai-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .eai-bc-sep img       { width: 22px; height: 22px; }
    .eai-inner            { padding: 0 16px; }
    .eai-main-section     { padding: 30px 0 60px 0; }
    .eai-main-row         { flex-direction: column; gap: 60px; }
    .eai-sidebar          { flex: none; width: 100%; }
    .eai-article-title    { font-size: 20px; margin-bottom: 15px; }
    .eai-article-body     { font-size: 14px; }
    .eai-article-body p   { margin-bottom: 15px; }
    .eai-article-body ol  { margin: 0 0 20px 0; gap: 10px; }
    .eai-article-body ol li { font-size: 14px; }
    .eai-meta-item        { font-size: 14px; }
    .eai-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .eai-h2               { font-size: 16px; margin: 30px 0 0px 0; }
    .eai-h3               { font-size: 14px; margin: 15px 0 0px 0; }
    .eai-nav-btn img      { width: 24px; height: 24px; }
    .eai-nav-btn          { font-size: 14px; }
    .eai-share-icon img   { width: 34px; height: 34px; }
    .eai-sidebar-title    { font-size: 20px; }
    .eai-hashtags         { margin-top: 30px; }
  }
`;

const recentPosts = [
       {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function HowESPImproveAirQualityIndustrialSettings() {
  return (
    <div className="eai">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="eai-hero">
        <img className="eai-hero-bg" src={HeroBgImg} alt="ESP Air Quality Industrial Hero" />
        <div className="eai-hero-overlay" />
        <div className="eai-hero-content">
          <h1 className="eai-hero-title">
            How Electrostatic Precipitators Improve Air Quality in Industrial Settings?
          </h1>
          <hr className="eai-hero-divider" />
          <p className="eai-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="eai-breadcrumb" aria-label="Breadcrumb">
        <div className="eai-breadcrumb-inner">
          <a href="/" className="eai-bc-item">Home</a>
          <span className="eai-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="eai-bc-item">News &amp; Updates</a>
          <span className="eai-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="eai-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="eai-main-section">
        <div className="eai-inner">
          <div className="eai-main-row">

            {/* ── ARTICLE ── */}
            <article className="eai-article">

              {/* Meta bar */}
              <div className="eai-meta-bar">
                <span className="eai-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="eai-meta-item"><img src={CalendarIcon} alt="date" /> January 24, 2025</span>
                <span className="eai-meta-item"><img src={ClockIconImg} alt="time" /> 7:00 am</span>
                <span className="eai-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="eai-article-title">
                How Electrostatic Precipitators Improve Air Quality in Industrial Settings?
              </h1>

              {/* Body */}
              <div className="eai-article-body">

                <p>The power generation, cement, steel, and pulp and paper industries are among the top sectors donating to a country's financial growth and development. Nevertheless, they also contribute significantly to air pollution. Reducing particulate emissions from these industries is a necessity. This reduction is needed for environmental sustainability and a requirement for strict compliance with air quality regulations. Among the tools effective for the industrial treatment of air pollutants, the <a href="/electrostatic-precipitators" className="eai-red-link">Electrostatic Precipitators</a> occupies a priority position.</p>

                {/* Article image */}
                <img className="eai-article-img" src={ArticleImg} alt="Electrostatic Precipitators Industrial Air Quality" />

                <p>Let's examine how <strong>Electrostatic Precipitators</strong> work, their role in improving air quality, and why they are indispensable in an industrial setting.</p>

                <span className="eai-h2">Understanding Electrostatic Precipitators?</span>

                <p>The general variety of electrostatic precipitators refers to mixed air pollution control instruments that regulate the precipitation of particulate matter from industrial exhaust gases, including dust, ash, and smoke. ESPs apply high-voltage electrical fields to charge particles in the gas stream, which causes them to stick to collection plates or other surfaces. Later, discharging less polluted air into the environment with broadly lower emissions is possible.</p>

                <p><strong>Let us understand how Electrostatic Precipitators work.</strong><br />
                The process involves several key steps:</p>

                <ol>
                  <li><span><strong>Ionization:</strong> As the exhaust gas passes through the ESP, high-voltage electrodes charge the particles.</span></li>
                  <li><span><strong>Particle Collection:</strong> The charged particles are attracted to oppositely charged plates or tubes where they stick.</span></li>
                  <li><span><strong>Particle Removal:</strong> Periodically, the collection plates are cleaned, and the collected particles are disposed of safely.</span></li>
                  <li><span><strong>Clean Air Release:</strong> The purified air is released into the environment, meeting strict air quality standards.</span></li>
                </ol>

                <p>This efficient mechanism makes ESPs highly effective in industries that generate significant particulate emissions.</p>

                <span className="eai-h2">The Role of ESPs in Industrial Air Quality Improvement</span>

                <span className="eai-h3">1.Significant Reduction in Emissions</span>
                <p>Electrostatic precipitators can remove up to 99% of particulate matter from industrial exhaust gases. It ensures compliance with environmental regulations and reduces the harmful effects of air pollution on nearby communities.</p>

                <span className="eai-h3">2.Adaptability to Various Industries</span>
                <p>ESPs are versatile and can handle various particulate sizes and compositions, making them suitable for power, cement, steel, and pulp and paper industries.</p>

                <span className="eai-h3">3.Energy Efficiency</span>
                <p>Modern ESPs are designed to operate with minimal energy consumption, ensuring cost-effectiveness while maintaining high performance.</p>

                <span className="eai-h3">4.Enhancing Workplace Safety</span>
                <p>By removing harmful particles from the air, ESPs create a cleaner and safer working environment for employees, reducing health risks associated with prolonged exposure to industrial emissions.</p>

                <span className="eai-h2">Why Electrostatic Precipitators Are a Long-Term Solution</span>

                <span className="eai-h3">1.Durability and Reliability</span>
                <p>ESPs are robust systems that, with proper maintenance, can operate efficiently for decades, making them a cost-effective investment.</p>

                <span className="eai-h3">2.Scalability</span>
                <p>ESPs can be customized to meet the specific requirements of different industries and plant sizes, ensuring optimal performance regardless of the application.</p>

                <span className="eai-h3">3.Technological Advancements</span>
                <p>With advanced transformer rectifier systems and software integration, ESPs offer greater precision and adaptability to meet evolving environmental standards.</p>

                <span className="eai-h2">ADOR Powertron: A Leader in ESP Solutions</span>

                <p>Keeping a trustworthy associate for <a href="understanding-electrostatic-precipitators-a-comprehensive-guide/" className="eai-red-link-plain">electrostatic precipitators</a> is essential to attaining optimal air quality. <strong>ADOR Powertron</strong> Ltd., a multinational leader in ESP technology, has set the standard with over 20,000 high-voltage transformer rectifier systems delivered across 82 nations. Their dedication to sustainability and pollution management makes ADOR a trusted enterprise member.</p>

                <span className="eai-h2">In essence</span>

                <p><strong>Electrostatic precipitators</strong> are essential in enhancing air quality in industrial environments. By efficiently catching particulate matter, they help industries decrease emissions and regulatory compliance and save the environment and public health.</p>

                <p><a href="/contact-us" className="eai-red-link">Invest in better air quality today—contact us to learn more about our advanced ESP solutions.</a></p>

                <p className="eai-hashtags">#ElectrostaticPrecipitator #IndustrialDustControl #AdorGroup #EmissionCompliance<br />#ESPPerformance #sustainability #suastainablesolutions</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="eai-bottom-row">
                <div className="eai-bottom-nav">
                  <a href="/news/role-transformer-bushings-safe-power-transmission" className="eai-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/emission-control-systems-industrial-challenges-solutions" className="eai-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="eai-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/how-electrostatic-precipitators-improve-air-quality-in-industrial-settings/" className="eai-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fhow-electrostatic-precipitators-improve-air-quality-in-industrial-settings%2F&mode=login" className="eai-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fhow-electrostatic-precipitators-improve-air-quality-in-industrial-settings%2F%26title%3DElectrostatic%2520Precipitators%2520Clean%2520Air%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fhow-electrostatic-precipitators-improve-air-quality-in-industrial-settings%2F" className="eai-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="eai-sidebar">

              {/* Recent Posts */}
              <div className="eai-sidebar-block">
                <p className="eai-sidebar-title">Recent Posts</p>
                <div className="eai-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="eai-recent-item">
                      <img src={post.img} alt={post.title} className="eai-recent-img" />
                      <div className="eai-recent-body">
                        <span className="eai-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="eai-sidebar-block">
                <p className="eai-sidebar-title">Social Media</p>
                <div className="eai-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="eai-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="eai-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}